import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NotificationsService } from "app/utils/notifications.service";
import { InformationPatient } from "app/models/information-patient";
import { Patients } from "app/models";
import { PatientService } from "app/core/patient.service";
import { UploadFileService } from "app/core/uploadFile.service";
import { NgbDateFRParserFormatter } from "app/ngb-date-fr-parser-formatter";
import { PatientAttente } from "app/models/patient-attente";

@Component({
  selector: "app-form-information-patient",
  templateUrl: "./form-information-patient.component.html",
  styleUrls: ["./form-information-patient.component.css"]
})
export class FormInformationPatientComponent implements OnInit {
  @Input()
  titre: string;
  @Input()
  information: InformationPatient;
  @Input()
  patient: Patients;

  @Input()
  patientAttente: PatientAttente;
  informationForm: FormGroup;

  currentFileUpload: File;
  selectedFiles: FileList;
  constructor(
    public activeModal: NgbActiveModal,
    private notification: NotificationsService,
    private fb: FormBuilder,
    private dateFormatteur: NgbDateFRParserFormatter,
    private patientService: PatientService,
    private uploadFileService: UploadFileService
  ) {}

  ngOnInit() {
    this.informationForm = this.fb.group({
      titre: [null, Validators.required],
      description: [null, Validators.required]
    });
    if (this.information) {
      this.informationForm.patchValue(this.information);
    }
  }

  submit(information: InformationPatient) {
    if (this.information) {

      information.id = this.information.id;
      information.user = this.information.user;
      if (this.information.patient){information.patient = this.information.patient;}
      if (this.information.patientAttente){information.patientAttente = this.information.patientAttente;}
      information.nombreUpdate= this.information.nombreUpdate;
      information.create= this.information.create;
      if(!information.nomFichier && this.information.nomFichier){
        information.nomFichier= this.information.nomFichier;
      }
      this.patientService.updateInformation(information).subscribe(
        data => {

          this.notification.addToast("Réussi", "Modification", "success");
        }
      );
    } else {

      if ( this.patient ) this.patient.datenaissance= this.dateFormatteur.format(this.patient.datenaissance);
      if ( this.patientAttente ) this.patientAttente.datenaissance= this.dateFormatteur.format(this.patientAttente.datenaissance);
      if (this.patient) {information.patient=this.patient;}
      if (this.patientAttente) {information.patientAttente=this.patientAttente;}
      information.id = null;

      this.patientService.createInformation(information).subscribe(
        data => {
          this.notification.addToast("Réussi", "Création", "success");
        }
      );
    }

    this.activeModal.close();
  }

  upload() {
    const value = this.informationForm.value;
    let information = new InformationPatient();
    information.titre = value.titre;
    information.description = value.description;
    if (this.currentFileUpload) {
      let name;
      if(this.patient){name =
        this.patient.nom +
        new Date().getTime() +
        "." +
        this.currentFileUpload.name.split(".")[
          this.currentFileUpload.name.split(".").length - 1
        ];
      }
      if(this.patientAttente){name =
        this.patientAttente.nom +
        new Date().getTime() +
        "." +
        this.currentFileUpload.name.split(".")[
          this.currentFileUpload.name.split(".").length - 1
        ];
      }

      this.uploadFileService
        .pushFileToStorage(this.currentFileUpload, this.patient, name)
        .subscribe(event => {
          information.nomFichier = name;
          this.submit(information);
        });
      this.selectedFiles = undefined;
    } else {

      this.submit(information);
    }
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.currentFileUpload = this.selectedFiles[0];
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/patients/form-information-patient/form-information-patient.component.ts